import React, { ReactElement } from "react";
import CustomIcon, { CustomIconName } from "../../core/custom-icon";
import { Box, Button } from "@material-ui/core";

export interface DashboardPanelEmptyStateProps {
  iconname: CustomIconName,
  linkUrl?: string;
  linkText?: string,
  children: ReactElement[] | ReactElement;
}

export const DashboardPanelEmptyState: React.FunctionComponent<DashboardPanelEmptyStateProps> = (props: DashboardPanelEmptyStateProps) => {
  return (
    <Box display='flex'
         flexDirection='column'
         height='100%'>
      <Box display='flex' pb={3}>
        <Box mr={{xs: 2, md: 3}}>
          <CustomIcon iconname={props.iconname} color='primary' viewBox='0 0 40 40' fontSize='large' />
        </Box>
        <Box flex='1 1 100%'>
          {props.children}
        </Box>
      </Box>
      { props.linkUrl && props.linkText ? (
      <Box mt='auto'
           pb={{xs: 1, md: 1.5}}
           textAlign='right'
      >
        <Button variant='text'
                endIcon={<CustomIcon iconname='arrowLong' />}
                component='a'
                href={props.linkUrl}
                target='_blank'
        >
          {props.linkText}
        </Button>
      </Box>
      ) : null}
    </Box>
  )
};
